<template>
  <div :class="classModifiers">
    <div class="podcasts__header" v-if="title">
      <div class="podcasts__header-title">
        {{ title }}
      </div>
      <div class="podcasts__header-arrows" v-if="showArrows">
        <span @click="prevSlide" :class="prevArrowModifiers"></span>
        <span @click="nextSlide" :class="nextArrowModifiers"></span>
      </div>
    </div>
    <div class="podcasts__content" @mouseenter="stopSwiper" @mouseleave="startSwiper">
      <swiper
        v-bind="swiperOptions"
        :modules="swiperModules"
        ref="swiper"
        @swiper="onSwiperReady"
        @transitionStart="onTransitionStart"
      >
        <swiper-slide v-for="(track, index) in tracks" class="podcasts__slide" :key="index">
          <iframe
            v-if="track.type === PODCAST.POLITICAN_TRADER"
            width="100%"
            :height="getTrackHeight(track, index)"
            :style="getTrackFrameStyle(track, index)"
            scrolling="no"
            frameborder="no"
            allowfullscreen
            webkitallowfullscreen
            mozallowfullscreen
            oallowfullscreen
            msallowfullscreen
            @load="onTrackFrameLoad"
            :src="getPoliticanTraderUrl()"
          ></iframe>
          <iframe
            v-if="track.type === PODCAST.SOUNDCLOUD"
            width="100%"
            :height="getTrackHeight(track, index)"
            :style="getTrackFrameStyle(track, index)"
            scrolling="no"
            frameborder="no"
            allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
            @load="onTrackFrameLoad"
            :src="getSoundCloudUrl(track.id)"
          ></iframe>
          <iframe
            v-if="track.type === PODCAST.APPLE"
            width="100%"
            :height="getTrackHeight(track, index)"
            :style="getTrackFrameStyle(track, index)"
            scrolling="no"
            frameborder="no"
            allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
            @load="onTrackFrameLoad"
            :src="getAppleUrl(track.id)"
          ></iframe>
          <iframe
            v-if="track.type === PODCAST.STITCHER"
            width="100%"
            :height="getTrackHeight(track, index)"
            :style="getTrackFrameStyle(track, index)"
            scrolling="no"
            frameborder="no"
            @load="onTrackFrameLoad"
            :src="getStitcherUrl(track.id)"
          ></iframe>
          <div
            class="podcasts__iframe podcasts__iframe--itunes"
            v-if="track.type === PODCAST.ITUNES"
          >
            <iframe
              :style="styleItunesIframe"
              scrolling="no"
              frameborder="no"
              @load="onTrackFrameLoad"
              :src="getItunesUrl(track.id)"
            ></iframe>
          </div>
          <div
            class="podcasts__backtrack"
            v-if="track.type === PODCAST.BACKTRACKS"
            :data-bt-embed="getBacktracksUrl(track.id)"
            data-bt-theme="dark"
            data-bt-show-description="false"
            data-bt-show-comments="false"
            data-bt-show-art-cover="false"
          ></div>
        </swiper-slide>
      </swiper>
      <div class="podcasts__link-wrapper" v-if="false">
        <strong>Special Offer:</strong>
        <a class="podcasts__link" href="https://lp.stratfor.com/predictitoffer" v-outer-link>
          Access Stratfor Worldview - Geopolitical Insights on What Moves Political Markets</a
        >
      </div>
    </div>
  </div>
</template>

<script src="./podcasts.js"></script>
<style src="./podcasts.scss" lang="scss"></style>
